<template>
  <div class="upcoming-minyan" v-html="content"></div>
</template>

<script>
// Paints an upcoming-minyan body on the display. The body is authored in the
// roll's "Upcoming" tab (a TipTap editor) and persisted as the entity's
// `displayContent` HTML, with `{name} {room} {time} {countdown}` plus one token
// per display toggle ({bruches} {hoidy} {ashrei} {borchy} {netz}) as placeholders. Display.vue resolves those placeholders
// against the roll's next (upcoming) minyan and passes the final HTML in here,
// so this component is purely presentational.
export default {
  name: 'Upcoming_Minyan_Render',
  props: {
    // Fully-resolved HTML to paint (placeholders already interpolated).
    content: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.upcoming-minyan {
  width: 100%;
  box-sizing: border-box;
}

/* The body is injected via v-html, so its nodes need :deep() to be reached by
   these scoped rules. Keep the rich-text defaults sane and self-contained. */
.upcoming-minyan :deep(p) {
  margin: 0 0 8px;
}

.upcoming-minyan :deep(p:last-child) {
  margin-bottom: 0;
}

.upcoming-minyan :deep(h1),
.upcoming-minyan :deep(h2),
.upcoming-minyan :deep(h3),
.upcoming-minyan :deep(h4) {
  margin: 0 0 8px;
}

.upcoming-minyan :deep(ul),
.upcoming-minyan :deep(ol) {
  margin: 0 0 8px;
  padding-left: 22px;
}

.upcoming-minyan :deep(img) {
  max-width: 100%;
  height: auto;
}

.upcoming-minyan :deep(a) {
  color: inherit;
}

.upcoming-minyan :deep([dir='rtl']) {
  direction: rtl;
  text-align: right;
}
</style>
